import { useContext, useEffect, useState } from 'react';
import './Bingo.scss'
import Challenge from './Challenge'
import api from '../../../../js/api';
import { UserContext } from '../../../../js/UserContext';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

export default function Board({ rows = 4, columns = 3, room = null, args = {} }) {
    /**
     * Board component for the Bingo game.
     * This component displays the Bingo board with challenges.
     */

    const { user, loading } = useContext(UserContext);
    const [challenges, setChallenges] = useState([]);
    const navigate = useNavigate();
    const s_params = useSearchParams();

    const get_user = async () => {
        let login = user?.login;
        const login_params = s_params[0].get('login');
        if (login_params)
            login = login_params;
        if (!login)
            return console.error('User login not available');

        return login;
    }

    const get_challenges = async () => {
        const login = await get_user();
        if (!login)
            return console.error('User login not available');

        const room_id = room.id;
        if (!room_id)
            return console.error('Room ID not available');

        const ch = await api.get(`/users/${login}/rooms/${room_id}/challenges`, { silent: true });
        if (ch && ch.error)
            return console.error('Error fetching challenges:', ch.error);

        if (ch && Array.isArray(ch) && ch.length) {
            setChallenges(ch);
            return;
        }
        let f = window.confirm('No challenges found. Would you like to create challenges? (yes/no)');
        console.log('User response:', f);
        if (f !== true) {
            console.warn('User declined to create challenges.');
            navigate('/misc/minigames/bingo', { replace: true });
            return;
        }
        // If no challenges found, create them
        const create_challenges = await api.post(`/users/${login}/rooms/${room_id}/challenges`, {});
        if (create_challenges && create_challenges.error)
            return console.error('Error creating challenges:', create_challenges.error);

        const new_challenges = await api.get(`/users/${login}/rooms/${room_id}/challenges`, { silent: true });
        if (new_challenges && new_challenges.error)
            return console.error('Error fetching challenges after creation:', new_challenges.error);
        setChallenges(new_challenges);
    }

    useEffect(() => {
        if (loading || !user || !user.login || !room || !room.id) {
            console.error('User not loaded or room not provided');
            return;
        }
        get_challenges();
    }, []);


    if (!rows || !columns || rows < 1 || columns < 1) {
        throw new Error('Invalid board dimensions. Rows and columns must be positive integers.');
    }

    if (!room)
        return <p>No room provided. Please select a room to play Bingo.</p>;
    if (!challenges)
        return <p>Loading challenges...</p>;

    return (
        <div className='bingo-board'>
            <div className='bingo-board-grid'>
                {challenges.map((c, index) => (
                    <Challenge key={index} className='bingo-board-cell' data={c}>
                        {/* <span className='bingo-board-text'>{c.c.title}</span> */}
                    </Challenge>
                ))}
            </div>
        </div>
    );
}